// extracted by mini-css-extract-plugin
export var actionButton = "_h7-0";
export var fileInput = "_h7-2";
export var paperclip = "_h7-1";